import { render } from "./Movies.vue?vue&type=template&id=18c7ae82&scoped=true"
import script from "./Movies.vue?vue&type=script&lang=js"
export * from "./Movies.vue?vue&type=script&lang=js"

import "./Movies.vue?vue&type=style&index=0&id=18c7ae82&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18c7ae82"]])

export default __exports__